import { Component, OnInit } from '@angular/core';
import { interval } from 'rxjs/observable/interval';
declare let $: any;


@Component({
  selector: 'app-diagnosis',
  templateUrl: './diagnosis.component.html',
  styleUrls: ['./diagnosis.component.css']
})
export class DiagnosisComponent implements OnInit {

  precentage: any = 1;
  startButton: boolean = false;
  timeOutStatus: boolean = false;

  constructor() { }

  ngOnInit() {

    // $('.loaders').css({ visibility: "visible", opacity: 0.0 }).animate({ opacity: 0.9 }, 100);
    // $(document).ready(function () {
    //   setTimeout(() => {
    //     $('.loaders').css({ visibility: "hidden", opacity: 0.9 }).animate({ opacity: 0 }, 500);  
    //   }, 4000);
      
    // })

    // (<any>window).gist.chat('hide');
  }

  loader() {



    $('#start').hide()
    this.startButton = true;
    var a = interval(30).subscribe(x => {
      if (this.precentage < 100)
        this.precentage = parseInt(this.precentage) + 1
      if (this.precentage == 100) {
        this.timeOutStatus = true;

        var gist = JSON.parse(localStorage.getItem('gist-state'))
        var full_story_time = localStorage.getItem('full_story_time')
        localStorage.clear()
        localStorage.setItem('gist-state', JSON.stringify(gist))
        localStorage.setItem('full_story_time', full_story_time)
        a.unsubscribe();
      }
    });
  }





}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/diagnosis/diagnosis.component.ts